var _style, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedalGold = function SvgMedalGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "medal-gold_svg__Layer_1_xA0_Image_00000059310149682323455240000013890203343768689031_",
    x: 0,
    y: 0,
    viewBox: "0 0 54 58"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".medal-gold_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.3 39-.2.4c-.2.4-.3.7-.5.9-.1.2-.3.4-.4.5s-.2.1-.4.1-.3-.1-.4-.2c-.2-.2-.4-.7-.5-1.4-.1-.5-.2-1-.2-1.4 0-.3 0-.5.1-.7l.4-.4c.2-.1.3-.1.6-.1.1 0 .2 0 .3.1.1 0 .1.1.1.3v.6c0 .5 0 1 .1 1.4v.3s0-.1.1-.1 0 0 0-.1V39c.2-.3.3-.8.5-1.2.2-.5.3-.8.4-1l.1-.1c.1-.1.3-.2.6-.2.1 0 .2 0 .3.1.1 0 .1.1.1.3 0 .1 0 .3.1.6 0 .2 0 .5.1.9s.1.8.2 1c0 .1.1.3.1.6.1-.2.1-.3.1-.5.1-.4.1-.9.1-1.6v-.2c0-.2 0-.4.1-.5s.1-.2.2-.3.2-.2.4-.2c.1-.1.2-.1.4-.1.1 0 .2 0 .3.1s.1.2.1.5q0 .75-.3 1.8c-.2.6-.4 1.2-.7 1.7-.1.2-.2.3-.3.4s-.2.2-.3.2-.2.1-.3.1c-.4 0-.8-.3-1-.8-.1-.2-.2-.3-.2-.6-.1-.2-.1-.5-.2-.7zm4.2 1.9c-.1 0-.2-.1-.4-.2-.1-.1-.2-.2-.2-.4-.1-.1-.1-.3-.1-.5 0-.5.1-1 .3-1.6s.4-1 .6-1.3c.1-.1.2-.2.4-.2s.3.1.4.2.2.4.2.6c0 .4-.1.8-.2 1.3s-.3 1-.4 1.6c-.1.2-.2.4-.3.4-.1.1-.2.1-.3.1m.6-4.4c-.3 0-.4-.2-.4-.5 0-.2 0-.3.1-.6.1-.2.2-.4.3-.5s.1-.1.2-.1h.2c.1 0 .2 0 .3.1s.1.2.1.4 0 .4-.1.6-.2.3-.3.5c-.2 0-.3.1-.4.1m2.9 2 .3-.3c.3-.3.5-.5.6-.7s.3-.2.4-.3.2-.1.4-.1.4.1.4.2c.1.1.1.3.1.6v2c0 .1 0 .2.1.3v.3c-.1.1-.2.2-.4.2-.1.1-.3.1-.4.1-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.3-.5s-.1-.4-.1-.7c0-.2 0-.4.1-.6l-.3.3c-.1.1-.1.2-.2.2-.3.4-.6.7-.8 1-.1.1-.2.2-.2.3-.2.4-.3.4-.4.4-.2 0-.3-.1-.5-.2s-.2-.3-.2-.5c0-.1 0-.3.1-.5 0-.2.1-.4.1-.6s.1-.5.2-.7.2-.5.2-.7c.1-.4.3-.6.5-.8.1-.1.3-.2.5-.2.3 0 .5.2.5.6 0 .2-.1.6-.2 1.1m4.3 1.1q0 .3.3.3c.2 0 .5-.1.9-.4.2-.2.3-.2.4-.2s.2 0 .2.1.1.1.1.2c0 0 0 .1-.1.2l-.5.5c-.2.2-.4.3-.6.4s-.4.2-.6.2c-.2.1-.4.1-.5.1q-.6 0-.9-.3c-.2-.2-.3-.5-.3-.8s.1-.6.2-.9.3-.7.5-.9q.3-.45.9-.9c.4-.3.8-.4 1.2-.4q.45 0 .6.3c.15.3.2.4.2.7 0 .2-.1.5-.2.7-.1.3-.3.5-.5.7s-.4.4-.6.5-.4.2-.5.2c-.1-.2-.2-.2-.2-.3m-.1-.1.3-.3c.2-.2.3-.4.4-.7.1-.2.1-.3.2-.5 0-.2.1-.4.1-.6s0-.2-.1-.2-.2.2-.4.6c-.1.2-.2.5-.3.8-.1.2-.1.5-.1.6-.1.1-.1.2-.1.3m6.9-1.5.1-.3c.1-.2.2-.4.4-.6s.2-.3.3-.3c.1-.1.2-.1.3-.2.1 0 .2-.1.3-.1.2 0 .4.1.6.2s.3.3.4.6c.1.2.1.5.1.8 0 .5-.1.9-.3 1.3s-.5.8-.8 1c-.3.3-.7.4-1 .4-.2 0-.4 0-.5-.1s-.3-.2-.4-.5v.2c-.2.6-.3 1.1-.5 1.3s-.2.5-.3.5c-.1.1-.1.1-.2.1-.2 0-.3-.1-.4-.2s-.2-.3-.2-.5c0-.3 0-.7.1-1.2s.2-.9.3-1.4.3-.9.4-1.3l.3-.6c.1-.2.2-.3.3-.4.1 0 .2-.1.2-.1.1 0 .2 0 .3.1s.1.2.1.3v.4c.1.2.1.4.1.6m-.4 1.8c.1.2.2.4.5.4.2 0 .3-.1.5-.2q.15-.15.3-.6c.15-.45.1-.5.1-.8V38c0-.2-.1-.2-.1-.2l-.2.2c-.1.2-.2.3-.4.5-.2.4-.4.8-.6 1.1 0 .1 0 .2-.1.2m6.3-.2c-.3.3-.5.6-.8.8s-.4.4-.6.5c-.2 0-.4.1-.6.1-.3 0-.6-.1-.8-.3s-.3-.5-.3-.8c0-.2 0-.5.2-.7.1-.3.2-.6.4-.8.3-.5.7-.8 1.2-1.1s.9-.5 1.4-.5c.4 0 .7.1.9.2.2.2.4.3.4.6 0 .2-.1.4-.2.5h.3s.1.1.1.2V40c0 .1.1.3.1.4-.2.2-.3.3-.5.4s-.3.1-.5.1c-.5 0-.7-.4-.7-1.1zm.2-1c-.3.1-.4.1-.5.1s-.2 0-.2-.1c0 0 0-.1.1-.2.2-.2.2-.5.2-.7 0-.1 0-.2-.1-.3 0-.1-.1-.2-.1-.2s-.1 0-.2.2q-.45.45-.6.9c-.15.45-.2.6-.2.8s0 .3.1.4.1.2.2.2.2-.1.5-.3c.2-.2.5-.4.8-.7zm3.8-.1.3-.3c.3-.3.5-.5.6-.7.2-.2.3-.2.4-.3s.2-.1.4-.1.3.1.4.2.1.3.1.6v2c0 .1 0 .2.1.3v.3c-.1.1-.2.2-.4.2s-.3.1-.4.1c-.2 0-.3-.1-.5-.2s-.2-.3-.3-.5-.1-.4-.1-.7v-.6l-.3.3-.2.2c-.3.4-.6.7-.8 1-.1.1-.2.2-.2.3-.1.4-.2.4-.4.4s-.3-.1-.5-.2-.2-.3-.2-.5v-.5c0-.2.1-.4.1-.6s.1-.5.2-.7.2-.5.2-.7c.1-.4.3-.6.5-.8.1-.1.3-.2.5-.2.3 0 .5.2.5.6.1.2.1.6 0 1.1m4.2 1.1c0 .2.2.3.3.3.2 0 .5-.1.9-.4.2-.2.3-.2.4-.2s.2 0 .2.1.1.1.1.2c0 0 0 .1-.1.2l-.5.5c-.2.2-.4.3-.6.4s-.4.2-.6.2c-.2.1-.4.1-.5.1q-.6 0-.9-.3c-.2-.2-.3-.5-.3-.8s.1-.6.2-.9.3-.7.5-.9c.2-.3.5-.6.8-.9.4-.3.8-.4 1.2-.4.3 0 .5.1.7.3s.2.4.2.7c0 .2-.1.5-.2.7-.1.3-.3.5-.5.7s-.4.4-.6.5-.4.2-.5.2c-.1-.2-.1-.2-.2-.3m0-.1.3-.3c.2-.2.3-.4.4-.7.1-.1.1-.3.1-.5s.1-.4.1-.6 0-.2-.1-.2-.2.2-.4.6c-.1.2-.2.5-.3.8s-.1.5-.1.6zm4.7-1.9c.1-.3.2-.7.3-1 .1-.4.1-.6.1-.8v-.1s-.1.1-.2.3l-.3.6c-.2.5-.3.9-.4 1.2s-.2.6-.2.8v.7c0 .2 0 .3.1.4 0 .1.1.1.2.1.2 0 .3-.1.5-.2s.4-.3.5-.6q.15-.3.3-.3c.1 0 .1.1.1.2q0 .45-.3.9c-.2.3-.5.5-.8.7s-.6.3-1 .3-.7-.1-1-.4-.4-.6-.4-1c0-.3.1-.7.2-1.2s.3-.9.6-1.3.5-.8.8-1.2.6-.6.8-.8c.2-.1.4-.2.6-.2s.3 0 .4.2c.1.1.2.2.3.4s.1.4.1.6c0 .5-.1.9-.3 1.3s-.4.8-.8 1.1l-.4.4c-.1.1-.3.1-.4.1s-.2 0-.2-.1c0 0 0-.1.1-.2.1-.2.2-.4.4-.7v-.1c.3 0 .3-.1.3-.1m-28.2 8.9v1.4h-.8v-4h1.6c.3 0 .6 0 .8.2.2.1.4.3.5.5s.2.4.2.7c0 .4-.1.7-.4.9s-.6.3-1.1.3zm0-.7h.7c.2 0 .4 0 .5-.2.1-.1.2-.2.2-.4s-.1-.3-.2-.5c-.1-.1-.3-.2-.5-.2h-.8v1.3zm6 .2c0 .4-.1.7-.2 1s-.3.5-.6.7-.5.2-.9.2c-.3 0-.6-.1-.9-.2-.3-.2-.5-.4-.6-.7s-.2-.6-.2-1v-.2c0-.4.1-.7.2-1s.3-.5.6-.7.5-.2.9-.2.6.1.9.2.5.4.6.7.2.6.2 1zm-.8-.2c0-.4-.1-.7-.2-1-.1-.2-.4-.3-.6-.3q-.45 0-.6.3c-.15.3-.2.5-.2.9v.3c0 .4.1.7.2 1 .1.2.4.3.6.3q.45 0 .6-.3c.1-.2.2-.5.2-1zm2.3 2.1h-.8v-4h.8zm4 0h-.8l-1.6-2.6v2.6H24v-4h.8l1.6 2.6v-2.6h.8zm3.7-3.4h-1.2v3.3h-.8v-3.3h-1.2v-.7h3.2zm2.5 2.3c0-.2 0-.3-.2-.4s-.3-.2-.6-.3-.5-.2-.7-.3c-.5-.2-.7-.6-.7-1 0-.2.1-.4.2-.6s.3-.3.5-.4.5-.1.8-.1.5 0 .8.2c.2.1.4.2.5.4s.2.4.2.6h-.8c0-.2-.1-.3-.2-.4s-.3-.2-.5-.2-.4 0-.5.1-.2.2-.2.3.1.2.2.3.3.2.6.2c.5.1.8.3 1 .5s.3.5.3.8-.1.6-.4.8-.6.3-1 .3c-.3 0-.6-.1-.8-.2s-.4-.3-.6-.5c-.1-.2-.2-.4-.2-.7h.9c0 .4.3.7.8.7.2 0 .3 0 .5-.1.1.3.1.2.1 0",
    className: "medal-gold_svg__st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2,
    cy: 28.9,
    r: 24,
    className: "medal-gold_svg__st0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "medal-gold_svg__SVGID_1_",
    x1: 21.855,
    x2: 31.147,
    y1: -9.337,
    y2: 63.746,
    gradientTransform: "matrix(1 0 0 -1 0 60)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3e868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#d18420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#fac73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    style: {
      stopColor: "#eaab2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#d28319"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    style: {
      stopColor: "#e7a632"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    style: {
      stopColor: "#f4bc41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#f9c447"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#fff5c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    style: {
      stopColor: "#fef0b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#fde18c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#facb4b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    style: {
      stopColor: "#f9bf2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    style: {
      stopColor: "#f9c232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#f9d15e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    style: {
      stopColor: "#f9de82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    style: {
      stopColor: "#f9e79f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#f9eeb3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#f9f3bf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9f4c3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27 50.6c-12.1 0-21.9-10-21.7-22C5.4 16.8 15 7 27.2 7.1c11.9.1 21.6 9.7 21.6 21.8 0 12-9.9 21.7-21.8 21.7",
    style: {
      fill: "url(#medal-gold_svg__SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "medal-gold_svg__SVGID_00000135652645797379135540000003058627327498044334_",
    x1: 0.688,
    x2: 53.316,
    y1: 31.149,
    y2: 31.149,
    gradientTransform: "matrix(1 0 0 -1 0 60)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3e868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#d18420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#fac73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    style: {
      stopColor: "#eaab2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#d28319"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    style: {
      stopColor: "#e7a632"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    style: {
      stopColor: "#f4bc41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#f9c447"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#fff5c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    style: {
      stopColor: "#fef0b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#fde18c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#facb4b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    style: {
      stopColor: "#f9bf2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    style: {
      stopColor: "#f9c232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#f9d15e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    style: {
      stopColor: "#f9de82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    style: {
      stopColor: "#f9e79f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#f9eeb3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#f9f3bf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9f4c3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 52.6c.4.1.9.1 1.3.1 1.5 0 3 .3 4.3 1 .9.4 1.7.8 2.7 1.1.8.3 1.7.4 2.5.1 1-.3 2-.8 2.9-1.2 1-.5 1.9-.9 3-1h.9c.7 0 1.9-.1 1.9-.1.5 0 .9-.1 1.4-.3.1 0 .1 0 .2-.1.7-.1 1.2-.4 1.7-.9.6-.6 1.2-1.3 1.7-2.1.4-.5.7-1 1.1-1.4.6-.7 1.3-1.2 2.1-1.6.9-.5 1.8-1.1 2.7-1.7.8-.6 1.3-1.3 1.6-2.3l.6-3c.1-.6.2-1.2.4-1.8.2-.7.6-1.2.9-1.8.5-.9 1.1-1.8 1.6-2.7.4-.8.6-1.6.4-2.4-.1-.6-.3-1.2-.5-1.8-.3-.8-.6-1.7-.8-2.5-.1-.5-.2-.9-.2-1.4 0-1.1.1-2.2.2-3.3v-1.7c0-.5-.2-1-.5-1.4-.4-.5-.8-1-1.2-1.4l-1.8-1.8c-.6-.5-1-1.2-1.3-1.9s-.6-1.4-.9-2-.5-1.2-.9-1.7c-.4-.7-.9-1.2-1.6-1.5-.4-.2-.8-.3-1.2-.5-.9-.3-1.9-.6-2.8-.9-.6-.2-1.2-.5-1.7-.8-.4-.3-.9-.7-1.3-1-.8-.6-1.5-1.2-2.3-1.7-.4-.3-.9-.5-1.4-.5-.7 0-1.4.1-2.1.2-.9.2-1.9.4-2.8.5-.4.1-.8.1-1.2.1-.5 0-1-.1-1.5-.2-1-.2-2-.4-3.1-.5-.6-.1-1.3-.1-1.9.2-.4.2-.7.4-1 .6-.9.6-1.7 1.3-2.5 1.9-.7.6-1.5 1.1-2.4 1.4-.8.2-1.6.5-2.4.7-.6.2-1.1.3-1.6.6-.7.1-1.1.4-1.5.8-.3.5-.5 1-.8 1.5-.3.7-.7 1.5-1 2.2s-.7 1.4-1.2 2c-.3.4-.7.7-1 1.1l-2.1 2.1c-.3.4-.7.9-.8 1.4-.1.4-.1.9-.1 1.3v.5c0 .5 0 1 .1 1.5s.1 1 .1 1.5c.1 1-.1 1.9-.4 2.8-.4 1.1-.8 2.3-1 3.5-.1.7-.2 1.4.1 2 .2.4.4.9.6 1.3.5.9 1.1 1.8 1.6 2.6.3.5.5.9.6 1.4.3 1 .4 1.9.6 2.9.1.7.3 1.4.5 2.1.2.4.4.8.7 1.2.5.4 1 .8 1.5 1.1.8.5 1.7 1 2.6 1.5.5.3.9.6 1.3 1 .4.5.9 1.1 1.3 1.6.6.8 1.2 1.5 1.9 2.2.4.4.9.7 1.5.8zM5.8 20.2c.5-1.1 1-2.2 1.6-3.2 1.2-2 2.6-3.7 4.4-5.3.3-.3.6-.5.9-.8l.5-.4c.4-.3.9-.6 1.3-.9 1.5-1 3.1-1.8 4.9-2.4Q23 6 26.6 6h2.1c.9.1 1.9.2 2.8.4 2.7.5 5.1 1.5 7.4 2.9 2.2 1.3 4.2 3 5.8 5.1 2.3 2.8 3.8 5.9 4.6 9.4.5 2.1.7 4.3.5 6.5-.1 1.2-.2 2.3-.5 3.5-.6 2.8-1.7 5.3-3.3 7.7q-1.8 2.7-4.2 4.8c-1.5 1.3-3.1 2.4-4.9 3.2-2.6 1.3-5.4 2-8.3 2.2-1.5.1-2.9.1-4.4-.1-2.2-.3-4.3-.8-6.3-1.7-2.4-1-4.6-2.4-6.5-4.2-1.7-1.6-3.2-3.4-4.4-5.5q-1.65-3-2.4-6.3c-.3-1.1-.4-2.3-.5-3.4-.1-1.5-.1-3 .1-4.6.2-1.7.6-3.4 1.2-5zM28.4 5.8",
    style: {
      fill: "url(#medal-gold_svg__SVGID_00000135652645797379135540000003058627327498044334_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 13.8c-1.2 0-2.8.1-2.9.2-.1 0-.2.2-.1.2s.1.3 0 .4v.2c.1.1.1.2.1.7v.6s-.1-.1-.1-.2c-.2-.4-.8-.9-1.3-1-.3-.1-.9-.1-1.1-.1-.9.1-1.8 1-2.1 2.1-.4 1.2-.1 2.8.6 4.1.5 1 1.8 2.3 2.9 3.1.4.3.6.4 1.7 1 .2.1.4.2.5.4.2.2.3.4.1.2-.3-.3-1-.1-1.1.3-.3.6.3 1.2 1 1.1.4-.1.6-.3.7-.7 0-.2 0-.2.1-.2 0 .1.2.4.4.9.3.6.4.8.4 1v.6c-.1.5-.1.6.1.8.1.1.3.2.4.2.1.1.3.2.4.3.4.3.5.6.2.6-.2 0-.3.2-.3.4 0 .3.2.5.8 1.2.7.7.7.8.8 1.4v.4h-.3c-.6.1-.9.3-1.1.7-.4.3-.4.3-.5.3-.8.2-1.1.3-1.2.8-.1.3-.1.3-.5.4s-.7.3-.8.4c-.1.2-.3 1-.4 1.6 0 .3-.1.9-.1 1.2-.1.9-.1.9-.7 1.1-.7.3-1 .5-1.2 1-.3.7 0 1.1 1.1 1.5.9.3 2 .5 3.7.6.9.1 1.5.1 2.9.1 1.8 0 2.7 0 4.2-.2 1.6-.2 2.8-.6 3.2-.9.3-.2.3-.6.1-1-.2-.5-.6-.8-1.3-1.1-.4-.1-.5-.2-.5-.5 0-.1-.1-.6-.1-1.2-.1-1.2-.1-1.5-.3-1.9-.2-.5-.3-.6-1-.8l-.4-.1.1-.2c0-.1-.1-.3-.2-.4s-.5-.3-.8-.4h-.4l-.2-.3c-.2-.4-.5-.6-1-.7h-.3v-.4c0-.6.1-.8.9-1.5.7-.7.9-1 .7-1.2 0-.1-.1-.2-.3-.2-.2-.1-.2-.1-.2-.2 0-.2.2-.3.7-.7.7-.4.7-.4.6-1v-.7c0-.1 0-.3.4-1.1.1-.2.2-.4.2-.5s.1-.2.1-.2 0 .1.1.2c0 .4.3.6.6.6.7.1 1.3-.5 1-1.1-.1-.3-.5-.5-.8-.5-.1 0-.2 0-.4.2l-.1.1.1-.1c.2-.2.4-.4 1.1-.8 1.2-.7 1.8-1.1 2.6-2 1.1-1.1 1.6-1.8 1.9-2.8.2-.7.3-1.1.3-1.8 0-.6 0-.7-.1-1.1-.3-.9-.9-1.7-1.6-2-.6-.3-1.4-.3-2.1 0-.4.2-.7.4-.9.8l-.1.3v-.6c0-.5 0-.6.1-.7.1 0 .1-.1 0-.2s-.1-.2 0-.4-.1-.3-2-.3c-.8-.2-5.7-.3-7-.3m-4.7 2c.1 0 .4.1.5.2.2.1.6.5.8.8s.3.8.3 1.2v.3l-.2-.1c-.2-.2-.5-.3-.7-.2-.4.1-.6.5-.5.9s.3.6.7.6.6-.1.7-.5c.1-.1.1-.3.1-.3v-.1s.1.2.1.5c0 .4.1 1.2.2 1.8.3 2.2.5 3.2.9 4.3l-.3-.3c-.2-.2-.6-.5-1.1-.8-.9-.6-1.2-.9-1.8-1.5-1.2-1.2-1.9-2.8-1.9-4.1 0-1.1.8-2.5 1.5-2.7.3-.1.4-.1.7 0m16.3.1c.3.1.7.6 1 1.2.6 1.2.4 2.5-.6 4.2-.7 1.1-1.5 1.9-3 2.9-.3.2-.6.5-.8.6-.1.2-.3.3-.3.2 0 0 0-.2.1-.3.3-.8.8-3.8 1-5.6 0-.2 0-.4.1-.5v-.2l.1.3c.1.5.4.7.8.7s.7-.2.7-.7c.1-.7-.7-1.1-1.2-.6l-.1.1v-.4c0-.2.1-.5.1-.6.2-.4.5-.9.8-1.1.4-.3 1-.4 1.3-.2m-15.2 2.3c.1 0 .2.1.2.3 0 .1.1.1.1.2.1.1.1.1.1.2s-.3.2-.5.2c-.4 0-.6-.4-.5-.7.1-.1.3-.3.4-.2zm13.9.1c.1.1.1.3 0 .5 0 .2-.1.2-.4.2-.2 0-.2 0-.4-.1l-.1-.1.1-.1c.1-.1.1-.1.1-.2.1-.3.5-.4.7-.2m-12.3 7.6c.2.2.2.3 0 .5-.1.1-.3.2-.5 0-.1-.1-.1-.6 0-.6.1-.1.4 0 .5.1m10.7-.1s.1.1.1.3 0 .3-.1.4c-.3.2-.7-.1-.5-.4 0-.3.3-.4.5-.3",
    style: {
      fill: "#b28029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 31.6c-.1.2-.3.5-.6 1s-.6.8-.7.9-.2.1-.3.1-.3-.1-.5-.2-.3-.3-.3-.5c0-.1.5-.9 1.5-2.3.5-.8 1-1.6 1.4-2.3.9-1.6 1.4-2.5 1.6-2.7s.4-.4.6-.4c.3 0 .5.1.7.2.1.1.1.2.1.4v.4c.7 2.1 1.2 3.6 1.6 4.4.4.9.8 1.5 1.2 1.9l.4.4c0 .1.1.2.1.3 0 .2-.1.4-.2.5-.2.1-.3.2-.5.2-.3 0-.6-.2-.9-.5-.6-.4-.8-.8-1.1-1.4s-.4-.9-.4-1c-.2 0-.7.1-1.4.2s-1.3.3-1.7.4c-.1 0-.2.1-.3.1s-.2-.1-.3-.1zm3.3-1.8c-.1-.2-.4-1-.8-2.4 0-.1-.1-.2-.1-.2l-1.6 3c.2 0 .5-.1.7-.1s.6-.1 1.3-.2c.1 0 .3 0 .5-.1zm8.4 0q0 .15-.9 1.8c0 .1-.1.2-.1.2-.6 1.3-1.1 1.9-1.5 1.9-.5 0-1-.7-1.4-2s-.6-2.5-.6-3.3c0-.3.1-.6.2-.8q.3-.3.6-.3c.2 0 .3.1.5.2.1.2.2.3.2.4l-.1.7v.7c0 .4.1.9.2 1.6.2.7.3 1 .3 1s.2-.3.6-1c.4-.9.8-1.5 1-2 .4-.7.7-1.2 1-1.4.2 0 .4.1.6.2.1.1.2.3.2.4v.5c0 1.1.3 2.2.9 3.1 0 0 .1 0 .1-.1s.1-.4.2-.8c.2-.9.5-1.6.8-2.3.3-.6.5-1 .7-1.2s.4-.2.6-.2c.1 0 .3.1.4.2s.2.2.2.4 0 .3-.1.4c-.5.6-.9 1.5-1.3 2.7s-.7 1.9-.8 2.2c-.2.3-.3.4-.4.4-.3 0-.6-.1-.9-.2-.2-.1-.4-.4-.6-.7.1-.5-.1-1-.2-1.5-.2-.5-.3-.9-.4-1.2zm9.5 1.7c-1 1.3-1.9 2-2.9 2-.3 0-.6-.1-.9-.4-.2-.3-.4-.6-.4-1 0-1 .4-2.1 1.3-3.2s1.8-1.7 2.7-1.7c.5 0 .8.2.9.7.4 0 .6.2.6.5 0 .2 0 .4-.1.9-.2.8-.2 1.4-.2 1.9s0 .8.1 1 .1.3.1.4.1.1.3.2.2.2.2.3c0 .2-.1.4-.3.5s-.4.2-.6.2c-.6-.2-.9-.9-.8-2.3zm-.4-3.1c-.4 0-.9.4-1.5 1.3q-.9 1.2-.9 2.1c0 .3.1.5.2.5.4 0 1-.4 1.6-1.2s1-1.5 1-2.1c0-.2 0-.3-.1-.4-.1-.2-.1-.2-.3-.2zm4.7 2.2.1-.2c.5-.9.9-1.7 1.5-2.2q.75-.9 1.5-.9.6 0 .9.3c.2.2.4.5.4.7s0 .3-.1.5c-.1.1-.2.2-.3.2q-.3 0-.6-.3c-.1-.1-.2-.2-.3-.2-.3 0-.8.4-1.4 1.3-.7.9-1.1 1.9-1.2 2.9 0 .3-.1.5-.3.7-.1.1-.3.2-.6.2s-.4-.1-.6-.4-.2-.8-.2-1.4v-1.1c0-.4.1-1 .1-1.6v-.4c0-.4.1-.6.1-.8 0-.1.1-.3.3-.4s.3-.2.5-.2.4.1.5.2.2.2.2.4-.1.5-.3 1.1c-.1.2-.1.4-.2.7zm8.4.9c-1 1.4-1.9 2.1-2.9 2.1-.4 0-.7-.2-1-.5-.2-.3-.4-.7-.4-1.2 0-1 .4-2 1.2-2.9q1.2-1.5 2.4-1.5c.5 0 .8.1 1 .4.3-1.2.4-2 .5-2.3.1-.6.2-.9.3-1.1s.2-.3.3-.4c.2-.1.3-.2.4-.2.2 0 .3.1.4.2.1.2.2.4.2.6 0 .1-.1.4-.2.9-.3.8-.5 1.8-.8 2.9-.2 1.1-.3 2.1-.3 2.7s.1 1 .4 1c.1 0 .3 0 .5-.1s.3-.1.3-.1q.3 0 .3.3c0 .3-.2.5-.6.8s-.7.4-1.1.4-.6-.2-.8-.6c-.1-.4-.2-.8-.1-1.4zm-.6-2.9c-.5 0-1 .4-1.5 1.1s-.8 1.4-.8 2.1c0 .4.1.5.4.5.5 0 1-.4 1.6-1.2s1-1.5 1-1.9c0-.1-.1-.3-.2-.4-.2-.1-.3-.2-.5-.2z",
    style: {
      stroke: "#231f20",
      strokeWidth: 0.25,
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }));
};
export default SvgMedalGold;